import type { Sokekilde } from '@helsenorge/core-cms/search-v2/types';

export type { Sokekilde };

export const sokekildeSearchParam = 'source';

const isSokekilde = (value: string): value is Sokekilde => value === 'input' || value === 'autosuggest';

export const parseSokekilde = (search: string): Sokekilde | undefined => {
  const values = new URLSearchParams(search).getAll(sokekildeSearchParam);

  if (values.length !== 1 || !isSokekilde(values[0])) {
    return undefined;
  }

  return values[0];
};
